import { locales, culturesWithStaticData } from './locales';

export function mapLocaleWebpack(locale) {
  let localeToLoad = locale;

  switch (localeToLoad.toLowerCase()) {
    case 'cs':
    case 'cs-CZ':
      localeToLoad = locales.Czech;
      break;
    case 'el':
    case 'el-GR':
      localeToLoad = locales.Greek;
      break;
    case 'fi':
    case 'fi-FI':
      localeToLoad = locales.Finnish;
      break;
    case 'hi':
    case 'hi-IN':
      localeToLoad = locales.Hindi;
      break;
    case 'hu':
    case 'hu-HU':
      localeToLoad = locales.Hungarian;
      break;
    case 'id':
    case 'id-ID':
      localeToLoad = locales.Indonesian;
      break;
    case 'ms':
    case 'ms-BN':
    case 'ms-MY':
      localeToLoad = locales.Malay;
      break;
    case 'nb':
    case 'nb-NO':
    case 'nn-NO':
      localeToLoad = locales.Norwegian;
      break;
    case 'pl':
    case 'pl-PL':
      localeToLoad = locales.Polish;
      break;
    case 'ro':
    case 'ro-RO':
      localeToLoad = locales.Romanian;
      break;
    case 'sv':
    case 'sv-FI':
    case 'sv-SE':
      localeToLoad = locales.Swedish;
      break;
    case 'uk':
    case 'uk-UA':
      localeToLoad = locales.Ukrainian;
      break;
    case 'vi':
    case 'vi-VN':
      localeToLoad = locales.Vietnamese;
      break;
    case 'bg':
    case 'bg-BG':
      localeToLoad = locales.Bulgarian;
      break;
    case 'da':
    case 'da-DK':
      localeToLoad = locales.Danish;
      break;
    case 'lt':
    case 'lt-LT':
      localeToLoad = locales.Lithuanian;
      break;
    case 'hr':
    case 'hr-HR':
      localeToLoad = locales.Croatian;
      break;
    case 'lv':
    case 'lv-LV':
      localeToLoad = locales.Latvian;
      break;
    case 'sl':
    case 'sl-SI':
      localeToLoad = locales.Slovenian;
      break;
    case 'en-dk':
    case 'en-in':
    case 'en-au':
    case 'en-ca':
    case 'en-ie':
    case 'en-nz':
    case 'en-ph':
    case 'en-gb':
    case 'en-us':
    case 'en-my':
    case 'en-sg':
    case 'en-nl':
    case 'en-th':
      localeToLoad = locales.English;
      break;
    case 'zh-hk':
    case 'zh-tw':
    case 'zh-hant':
      localeToLoad = locales.ChineseTrad;
      break;
    case 'zh-cn':
    case 'zh-hans':
      localeToLoad = locales.ChineseSimplified;
      break;
    case 'fr-ca':
    case 'fr-fr':
      localeToLoad = locales.French;
      break;
    case 'de-at':
    case 'de-de':
    case 'de-ch':
      localeToLoad = locales.German;
      break;
    case 'it-it':
    case 'it':
      localeToLoad = locales.Italian;
      break;
    case 'nl':
    case 'nl-nl':
      localeToLoad = locales.Dutch;
      break;
    case 'pt-br':
      localeToLoad = locales.Portugese;
      break;
    case 'es-ar':
    case 'es-cl':
    case 'es-co':
    case 'es-mx':
    case 'es-pe':
    case 'es-es':
    case 'es-ve':
      localeToLoad = locales.Spanish;
      break;
    case 'ja-jp':
    case 'ja':
      localeToLoad = locales.Japanese;
      break;
    case 'ko-kr':
    case 'ko':
      localeToLoad = locales.Korean;
      break;
    case 'ru':
    case 'ru-ru':
      localeToLoad = locales.Russian;
      break;
    case 'th':
    case 'th-th':
      localeToLoad = locales.Thai;
      break;
    case 'tr':
    case 'tr-tr':
      localeToLoad = locales.Turkish;
      break;
    case 'fil':
    case 'fil-ph':
      localeToLoad = locales.Filipino;
      break;
    default:
      localeToLoad = locales.English;
      break;
  }
  return localeToLoad;
}


export function mapLocaleRjs(locale) {
  let cultureToLoad = locale;

  switch (cultureToLoad) {
    case 'zh-HK':
    case 'zh-TW':
      cultureToLoad = 'zh-Hant';
      break;
    default:
      break;
  }

  return cultureToLoad;
}

export function mapLocaleToLcid(locale) {
  const realLocale = mapLocaleWebpack(locale);

  return culturesWithStaticData[realLocale] || culturesWithStaticData[locales.English];
}
